import { Pipe, PipeTransform } from "@angular/core";
import { fieldIcon } from "../../shared/models/icons.model";

@Pipe({
  name: "setFieldIcon",
  standalone: false,
})
export class SetFieldIconPipe implements PipeTransform {
  transform(field: any, groupType: string, param: string): string {
    let fieldSpecs = "";
    if (["Models", "Calculated Metrics"].includes(groupType)) {
      fieldSpecs = field.path;
    }
    if (["Chat Transcript Fields"].includes(groupType)) {
      fieldSpecs = field.name;
    }
    if (["NLP", "Structured Fields"].includes(groupType)) {
      fieldSpecs = field.type;
    }
    return fieldIcon[fieldSpecs]?.[param];
  }
}
